import React from "react";

import { Form } from "react-bootstrap";

import { isString } from "lodash";
import { FieldError } from "react-hook-form";

interface FormErrorTextProps {
  error: FieldError | string | undefined;
  message?: string;
}

export const FormErrorText = ({ error, message }: FormErrorTextProps) =>
  error ? <Form.Text className="text-danger">{message || (isString(error) ? error : error.message)}</Form.Text> : <></>;
